import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { UbicacionService } from 'src/app/services/catalogos/ubicacion.service';
import { TableComponent } from 'src/app/shared/components/common/tables/table/table.component';
import { merge, of } from 'rxjs';
import { catchError, debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { AddUbicacionComponent } from 'src/app/modules/shared/add-ubicacion/add-ubicacion.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/common/modals/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-lista-ubicaciones',
  templateUrl: './lista-ubicaciones.component.html',
  styleUrls: ['./lista-ubicaciones.component.sass']
})
export class ListaUbicacionesComponent implements OnInit {

  isLoading = true;
  usuarios;

  displayedColumns = ["Acciones", "Nombre", "Direccion", "Activo"]; //"patente", "aduana", "pedimento", "eta"
  vals = [
    { nombreColumna: "Acciones", campo: "", tipoChip: false },
    { nombreColumna: "Nombre", campo: "nombre", tipoChip: false },
    { nombreColumna: "Direccion", campo: "direccion", tipoChip: false },
    { nombreColumna: "Activo", campo: "active", tipoChip: true }
  ];

  status = [{ id: '0', nombre: 'Inactivo', color: 'gray' }, { id: '1', nombre: 'Activo', color: 'green' }]

  getStatus(tipo, id) {
    if (tipo == "active") {
      return this.status.find(st => st.id == id);
    }
  }
  obtenerValor(row) {
    if (typeof row === 'object' && row !== null) {
      return row.descripcion;//[val.campo]
    }
    else {
      return row;
    }
  }
  getObj(value) {
    return this.vals.find(val => val.nombreColumna === value);
  }
  AbrirMenu() {
    this.trigger.openMenu();
  }

  resultsLength = 0;
  pageSize = 10;
  searchBy = { value: "nombre", text: 'Nombre' }
  attributes = 'attributes[0]=idUbicacion&attributes[1]=nombre&attributes[2]=direccion&attributes[3]=latitud&attributes[4]=longitud&attributes[5]=active';
  filters = 'filters[active][eq]=1' // 'filters[status][in]=1,0&filters[fechaSolicitud][between]=2021-08-01,2021-09-12';
  busquedasDispoible = [];

  searchOptions: any[] = [{ value: "fase", text: 'Fase' },
  { value: "movilidad", text: 'Movilidad' },
  { value: "internacional", text: 'Internacional' },
  { value: "otroServicio", text: 'Otro Servicio' },
  ];
  panelOpenState = false;

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input() resultadoReporte;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(TableComponent, { static: false }) public table: TableComponent<any>;
  constructor(private _us: UbicacionService, private _router: Router, private _dialog: MatDialog, private _sb: MatSnackBar) { }

  ngOnInit(): void {
    // console.log(this.resultadoReporte);
    this.displayedColumns = [...this.displayedColumns];
    // this.servicios = this.resultadoReporte;

    console.log("Esta es la lista de servicios");
  }

  ngAfterViewInit() {
    this.actualizarReporte()
  }
  handleSearchChange(event) {
    console.log("Busqueda del reporte");
  }
  verMas(element) {
    console.log("Ver mas");
  }
  actualizarReporte() {
    merge(this.table.sort.sortChange, this.table ? this.table.paginator.page : [], this.table.searchValue.valueChanges.pipe(debounceTime(500)))
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          // let chipsFilters = this.agregarFiltros();
          return this._us.getUbicaciones(`${this.attributes}&${this.filters}${this.table.searchValue.value ? `&filters[${this.searchBy.value}][like]=%25${this.table.searchValue.value.replace("&", "%26")}%25` : ''}&size=${this.table.paginator.pageSize}&page=${this.table.paginator.pageIndex}`);
        }),
        map((data: any) => {
          this.isLoading = false;
          this.resultsLength = data.count;
          return data.rows
          //return [];
        }),
        catchError(() => {
          this.isLoading = false;

          return of([]);
        })
      )
      .subscribe((data: any) => {
        if (data) {
          // this._ss.setPreference("pageSize", this.table.paginator.pageSize.toString());
          this.usuarios = data;
          // this.getFiltros();

        } else {
          this.usuarios = [];
        }
      });
  }

  verifica(id) {
    // console.log(id)
    // console.log(`verificacion/${id}`);
    // this._router.navigate([`servicios/verificacion/${id}`])
  }

  edita(ubicacion) {
    // console.log(id)
    // console.log(`editar/${id}`);
    // this._router.navigate([`servicios/registro/${id}`])
    this.showAgregaUbicacion(ubicacion)
  }

  desactiva(ubicacion) {
    this.showConfirmaDesactivar({ title: "Desactivar", message: `Confirma desactivar el producto ${ubicacion.nombre}`, cancelButton: "Cancelar", okButton: "Aceptar" }, ubicacion)
  }

  asigna(servicio) {
  }

  imprimir(idServicio) {
  }

  agregaUsuario() {
    // this._router.navigate([`servicios/registro/new`])

  }



  async showAgregaUbicacion(ubicacion) {
    const dialogRef = this._dialog.open(AddUbicacionComponent, {
      // panelClass: "sixtyprc-dialog",
      disableClose: false,
      // maxHeight: '60%',
      data: ubicacion
    });
    dialogRef.afterClosed().subscribe(async result => {
      try {
        console.log(result);
        if (result) {
          this.actualizarReporte()
          // this._servicioService.patchServicio(this.idServicio, { action: 3 })
          // this._snakBar.open("Servicio Finalizado!", "Aviso", { duration: 3000 })
        }
      } catch (err) {
        // console.log(err);
        // this._snakBar.open("Error al finalizar el servicio", "Error", { duration: 3000 })
      }
    })
  }
  async showConfirmaDesactivar(parametros, ubicacion) {
    const dialogRef = this._dialog.open(ConfirmDialogComponent, {
      panelClass: "sixtyprc-dialog",
      disableClose: true,
      maxHeight: '60%',
      data: {
        confirmDialogData: {
          title: parametros.title, message: parametros.message, cancelButton: parametros.cancelButton, okButton: parametros.okButton
        }
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      try {
        console.log(result);
        if (result) {
          await this._us.patchUbicacion(ubicacion.idUbicacion, "deactivate", {})
          this.actualizarReporte()
        }
      } catch (err) {
        console.log(err);
        this._sb.open("Error al Desactivar el producto", "Error", { duration: 3000 })
      }
    })
  }

}
